import { render, staticRenderFns } from "./posPerformanceChart.vue?vue&type=template&id=5986cc6a&"
import script from "./posPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./posPerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports